const IMPERSONATION_KEY = 'kart_impersonation'
const ADMIN_SESSION_KEY = 'kart_impersonation_admin'

export function getImpersonationState() {
  try {
    const raw = localStorage.getItem(IMPERSONATION_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function getAdminSession() {
  try {
    const raw = localStorage.getItem(ADMIN_SESSION_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function startImpersonation({ targetEmail, adminSession }) {
  localStorage.setItem(IMPERSONATION_KEY, JSON.stringify({ targetEmail }))
  localStorage.setItem(ADMIN_SESSION_KEY, JSON.stringify(adminSession))
  window.dispatchEvent(new Event('kart_impersonation_change'))
}

export function clearImpersonation() {
  localStorage.removeItem(IMPERSONATION_KEY)
  localStorage.removeItem(ADMIN_SESSION_KEY)
  window.dispatchEvent(new Event('kart_impersonation_change'))
}
